<!-- SearchInput.vue -->
<template>
  <div class="search">
    <div>
      <input
        type="text"
        v-model="model"
        :placeholder="$t('params.search')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    value: { type: String, default: '' }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  width: 100%;
  height: 100%;

  input {
    width: 100%;
    @include background(
      $image: img("magnify.svg"),
      $position: right 5px center,
      $size: 22px
    );
    padding: 10px 30px 10px 15px;
    border: 1px solid $secondary-color;
    outline: none;
    font-size: 11pt;
    border-radius: 3px;
    color: $dark-color;

    &::placeholder {
      color: $dark-color;
      opacity: 0.5;
    }
  }
}

@include media("<=desktop") {
  .search {
    input {
      width: 100%;
    }
    width: 100%;
    margin-top: 12px;
  }
}
</style>
